import React from "react";
import { Link } from "gatsby";
import { Button, Box, useTheme } from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";

function MoreButton({
	to,
	toLabel = "Learn More",
	variant,
	color = "primary",
	sx,
	size,
	link,
	fullWidth = false,
}) {
	const is_external = to.includes("http");
	const theme = useTheme();
	if (link) {
		let link_attrs = {
			display: "flex",
			component: is_external ? "a" : Link,
			target: is_external ? "_blank" : "_self",
			sx: {
				color: theme.palette.link.main,
				textDecoration: "none",
				alignItems: "center",
				"&:hover, &:active, &:focus": {
					color: theme.palette.link.hover,
					textDecoration: "underline",
				},
			},
		};
		if (is_external) {
			link_attrs.href = to;
		} else {
			link_attrs.to = to;
		}
		return (
			<Box className="more-link" {...link_attrs}>
				{toLabel} <ArrowRightAltIcon />
			</Box>
		);
		// if (is_external) {
		// 	return (
		// 		<a href={to} target="_blank">
		// 			{toLabel} <ArrowRightAltIcon />
		// 		</a>
		// 	);
		// } else {
		// 	return (
		// 		<Link to={to}>
		// 			{toLabel} <ArrowRightAltIcon />
		// 		</Link>
		// 	);
		// }
	} else {
		const component = is_external ? "a" : Link;
		const attrs = { component };
		if (color === "primary" || color === "secondary") {
			attrs.color = color;
		}
		attrs.target = is_external ? "_blank" : "_self";
		if (is_external) {
			attrs.rel = "noreferrer";
		}
		if (sx) attrs.sx = sx;
		if (variant) {
			attrs.variant = variant;
			attrs.color = color;
		}
		if (is_external) {
			attrs.href = to;
		} else {
			attrs.to = to;
		}
		if (size) {
			attrs.size = size;
		}
		return (
			<Button {...attrs} fullWidth={fullWidth}>
				{toLabel}
			</Button>
		);
	}
}

export default MoreButton;
